import { summaryBtnOption } from './alert-summary.component';

export const ALERT_SUMMARY_BUTTON_OPTIONS: summaryBtnOption[] = [
  {
    key: 'temperature',
    type: 'sensor',
    label: '温度',
    iconName: 'thermostat',
    unit: '℃',
  },
  {
    key: 'humidity',
    type: 'sensor',
    label: '湿度',
    iconName: 'water_drop',
    unit: '%',
  },
  {
    key: 'pressure',
    type: 'sensor',
    label: '気圧',
    iconName: 'speed',
    unit: 'hPa',
  },
  {
    key: 'light',
    type: 'sensor',
    label: '照度',
    iconName: 'wb_sunny',
    unit: 'lx',
  },
  {
    key: 'tilt',
    type: 'sensor',
    label: '傾斜',
    iconName: 'rotate_90_degrees_ccw',
    unit: '°',
  },
  {
    key: 'fallDetected',
    type: 'event',
    label: '落下',
    iconName: 'airline_stops',
    unit: '',
  },
  {
    key: 'mcdDetected',
    type: 'event',
    label: '動作',
    iconName: 'motion_photos_on',
    unit: '',
  },
  {
    key: 'lightExposure',
    type: 'event',
    label: '明暗',
    iconName: 'contrast',
    unit: '',
  },
  {
    key: 'shockDetected',
    type: 'event',
    label: '衝撃',
    iconName: 'flash_on',
    unit: '',
  },
] as const;
